"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const lodash_1 = require("lodash");
const utils_1 = require("./utils");
const deprecatedMethod_1 = require("../utils/deprecatedMethod");
class Form {
    constructor({ fields, onSubmit = () => undefined }) {
        Object.defineProperty(this, "fields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submitAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_isSubmitting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fields = fields;
        this.submitAction = (0, utils_1.wrapInAsyncAction)(onSubmit);
        this._isSubmitting = false;
        this.attachFields();
        (0, mobx_1.makeObservable)(this, {
            fields: mobx_1.observable,
            submitAction: mobx_1.observable,
            _isSubmitting: mobx_1.observable,
            values: mobx_1.computed,
            dirtyValues: mobx_1.computed,
            isValid: mobx_1.computed,
            isDirty: mobx_1.computed,
            isReadyToSubmit: mobx_1.computed,
            isSubmitting: mobx_1.computed,
            submit: mobx_1.action,
            clear: mobx_1.action,
            reset: mobx_1.action,
            showErrors: mobx_1.action
        });
    }
    get values() {
        return (0, utils_1.valuesOf)(this.fields);
    }
    get dirtyValues() {
        return (0, utils_1.valuesOf)(this.dirtyFields);
    }
    get isValid() {
        return (0, lodash_1.every)(this.enabledFields, field => field.isValid);
    }
    get isDirty() {
        return (0, lodash_1.some)(this.fields, field => field.isDirty);
    }
    get isReadyToSubmit() {
        return this.isValid && this.isDirty && !this.isSubmitting;
    }
    get isSubmitting() {
        return this._isSubmitting;
    }
    field(fieldKey) {
        return this.fields[fieldKey];
    }
    select(fieldKey) {
        (0, deprecatedMethod_1.default)('Form', 'select', { alternative: 'field', docsPath: '/reference/Form.md#field' });
        return this.field(fieldKey);
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.syncFieldErrors();
            if (!this.isValid || this.isSubmitting)
                return;
            yield this.executeSubmitAction();
        });
    }
    clear() {
        this.eachField(field => field.clear());
    }
    reset() {
        this.eachField(field => field.reset());
    }
    showErrors(errors) {
        (0, lodash_1.forEach)(errors, (error, fieldKey) => this.showErrorOnField(fieldKey, error));
    }
    attachFields() {
        (0, lodash_1.forEach)(this.fields, field => field.attachToForm(this));
    }
    get dirtyFields() {
        return this.pickFieldsBy(field => field.isDirty);
    }
    get enabledFields() {
        return this.pickFieldsBy(field => !field.isDisabled);
    }
    pickFieldsBy(predicate) {
        return (0, lodash_1.pickBy)(this.fields, predicate);
    }
    syncFieldErrors() {
        (0, lodash_1.forEach)(this.fields, field => field.syncError());
    }
    executeSubmitAction() {
        this._isSubmitting = true;
        return this.submitAction(this)
            .finally((0, mobx_1.action)(() => { this._isSubmitting = false; }));
    }
    eachField(actionOnField) {
        (0, lodash_1.forEach)(this.fields, actionOnField);
    }
    showErrorOnField(fieldKey, error) {
        var _a;
        (_a = this.fields[fieldKey]) === null || _a === void 0 ? void 0 : _a.showError(error);
    }
}
exports.default = Form;
